import React from 'react';

const AdminInfoForm = (props) => (
  <form>
    <div className="form-group">
      <input
        type="text"
        onChange={props.handleChange('status')}
        placeholder="Judul"
        className="form-control"
        values={props.values.status}
        />
    </div>
    <div className="form-group">
      <input
        type="text"
        onChange={props.handleChange('information')}
        placeholder="Informasi"
        className="form-control"
        values={props.values.information}
        />
    </div>

    <div className="form-group">
      <textarea
        type="text"
        onChange={props.handleChange('details')}
        placeholder="Nomor Telpon Kurir"
        className="form-control"
        values={props.values.details}
        />
    </div>
  </form>
)


export default AdminInfoForm
